class Controller {
  constructor($mdDialog, $injector, officeLocation) {
    "ngInject";

    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.officeLocation = officeLocation;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/removeOfficeLocationDialog/removeOfficeLocationDialog.controller.js